// src/components/superadmin/BusinessCardViewer.jsx
import React, { useState, useEffect } from 'react';
import '../../styles/businesscards.css';

function BusinessCardViewer({ staff, onClose }) {
  const [showBack, setShowBack] = useState(false);

  // DEBUG: Log the staff data when component loads
  useEffect(() => {
    console.log('=== BUSINESS CARD VIEWER DEBUG ===');
    console.log('Full staff object:', staff);
    console.log('Logo URL:', staff.logoUrl);
    console.log('Logo Back URL:', staff.logoUrlBack);
    console.log('QR Code URL:', staff.qrCodeUrl);
    console.log('Phone:', staff.phone);
    console.log('================================');
  }, [staff]);

  const handleCardClick = () => {
    setShowBack(!showBack);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleImageError = (type, url) => {
    console.error(`Failed to load ${type} image from:`, url);
  };

  const handleImageLoad = (type) => {
    console.log(`${type} loaded successfully`);
  };

  return (
    <div className="card-viewer-overlay" onClick={handleOverlayClick}>
      <button className="close-viewer" onClick={onClose}>×</button>
      
      <div className={`business-card-3d ${showBack ? 'flipped' : ''}`} onClick={handleCardClick}>
        {/* FRONT FACE */}
        <div className="card-face card-front-face">
          <div className="card-top-section">
            {staff.logoUrl ? (
              <img 
                src={staff.logoUrl} 
                alt="Logo" 
                className="card-logo-img"
                onError={() => handleImageError('logo', staff.logoUrl)}
                onLoad={() => handleImageLoad('Logo')}
              />
            ) : (
              <div className="card-logo-placeholder">INSERT LOGO HERE</div>
            )}
          </div>
          <div className="card-bottom-section">
            <div className="card-info-column">
              <div className="card-job-title">{staff.title || 'Title'}</div>
              <div className="card-name">{staff.name || 'Name'}</div>
              <div className="card-contact-info">
                <div className="card-contact-item">
                  <div className="card-contact-icon">📞</div>
                  <div className="card-contact-text">{staff.phone || 'Phone'}</div>
                </div>
                <div className="card-contact-item">
                  <div className="card-contact-icon">✉</div>
                  <div className="card-contact-text">{staff.email}</div>
                </div>
                <div className="card-contact-item">
                  <div className="card-contact-icon">📍</div>
                  <div className="card-contact-text">{staff.address}</div>
                </div>
                <div className="card-contact-item">
                  <div className="card-contact-icon">🌐</div>
                  <div className="card-contact-text">www.bespokecrm.cloud</div>
                </div>
              </div>
            </div>
            <div className="card-qr-column">
              {staff.qrCodeUrl ? (
                <img 
                  src={staff.qrCodeUrl} 
                  alt="QR Code" 
                  className="card-qr-img"
                  onError={() => handleImageError('QR code', staff.qrCodeUrl)}
                  onLoad={() => handleImageLoad('QR code')}
                />
              ) : (
                <div className="card-qr-placeholder">INSERT QR CODE HERE</div>
              )}
            </div>
          </div>
        </div>

        {/* BACK FACE */}
        <div className="card-face card-back-face">
          <div className="card-back-content">
            {staff.logoUrlBack ? (
              <img 
                src={staff.logoUrlBack} 
                alt="Logo Back" 
                className="card-logo-back-img"
                onError={() => handleImageError('logo back', staff.logoUrlBack)}
                onLoad={() => handleImageLoad('Logo back')}
              />
            ) : (
              <div className="card-logo-back-placeholder">INSERT LOGO HERE</div>
            )}
          </div>
        </div>
      </div>
      
      <div className="card-instruction">Click card to flip</div>
    </div>
  );
}

export default BusinessCardViewer;